'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _performanceUuid = require('performance-uuid');

var _performanceUuid2 = _interopRequireDefault(_performanceUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'spinner';
  return 'brsk-' + name + '-' + (0, _performanceUuid2.default)();
};


//////////////////
// WEBPACK FOOTER
// ./~/better-react-spinkit/dist/util/animationName.js
// module id = 142
// module chunks = 0